import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";

const MBOForm = ({ formData, handleInputChange, isMobile, isMboView }) => {
  // Define the quarters array with label and target names

  const [alignmentClass, setAlignmentClass] = useState("border-top");
  const quarters = [
    { label: "Quarter - 1 (January, February and March)", name: "target1" },
    { label: "Quarter - 2 (April, May and June)", name: "target2" },
    { label: "Quarter - 3 (July, August and September)", name: "target3" },
    { label: "Quarter - 4 (October, November and December)", name: "target4" },
  ];

  useEffect(() => {
    // Update the alignment class based on whether it's mobile or not
    if (isMobile) {
      setAlignmentClass("border-start border-end p-2"); // No text-center on mobile devices
    }
  }, [isMobile]); // This runs once after the component mounts

  return (
    <>
      {quarters.map((quarter, index) => (
        <RB.Row key={index}>
          <RB.Col
            className="border-start border-end border-top p-1 d-flex justify-content-md-center align-items-md-center text-md-center"
            md={4}
          >
            {quarter.label}
          </RB.Col>
          <RB.Col
            className={` ${
              isMboView ? "ps-2" : "text-center"
            } p-1  border-end ${alignmentClass}`}
            md={8}
          >
            {isMboView === true ? (
              formData[quarter.name]
            ) : (
              <RB.Form.Control
                type="text"
                placeholder={`Enter ${
                  quarter.label.split(" ")[0] + " " + (index + 1)
                } Target`} // dynamic placeholder
                name={quarter.name}
                value={formData[quarter.name]}
                onChange={handleInputChange}
                required
                maxLength={10}
              />
            )}
          </RB.Col>
        </RB.Row>
      ))}
    </>
  );
};

export default MBOForm;
